/* eslint-disable no-shadow */
import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TouchBackend } from 'react-dnd-touch-backend';
import {
  faAddressBook,
  faArrowsAlt,
  faAt,
  faBell,
  faBuilding,
  faCalendarAlt,
  faCarBattery,
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCheck,
  faCheckCircle,
  faChevronLeft,
  faChevronRight,
  faClock,
  faCompressArrowsAlt,
  faDiceD20,
  faDownload,
  faEdit,
  faEye,
  faEyeSlash,
  faFax,
  faFile,
  faFileDownload,
  faFileUpload,
  faFrown,
  faGlobeAmericas,
  faHashtag,
  faKey,
  faLeaf,
  faListAlt,
  faLocationArrow,
  faLock,
  faMapMarkerAlt,
  faMarker,
  faMicrochip,
  faMinus,
  faMinusCircle,
  faNetworkWired,
  faPaperclip,
  faPhone,
  faPhoneAlt,
  faPhoneSquareAlt,
  faPlug,
  faPlus,
  faPlusCircle,
  faListUl,
  faMapMarkedAlt,
  faPowerOff,
  faQuestion,
  faSave,
  faServer,
  faSignature,
  faSignInAlt,
  faSignOutAlt,
  faSimCard,
  faSmile,
  faSort,
  faSortDown,
  faSortUp,
  faSpinner,
  faStar,
  faTabletAlt,
  faTimes,
  faTrashAlt,
  faTrophy,
  faUpload,
  faUser,
  faUsers,
  faWindowClose,
  faWrench,
  faAngleDown,
  faWifi,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons';
import { faAddressCard } from '@fortawesome/free-solid-svg-icons/faAddressCard';
import { faEthernet } from '@fortawesome/free-solid-svg-icons/faEthernet';
import IdleTimer from 'react-idle-timer';
import { connect } from 'react-redux';
import { toast, ToastContainer } from 'react-toastify';
import * as CompanyActions from './actions/Companies';
import * as BoxesActions from './actions/EpikBoxes';
import * as UserActions from './actions/User';
import { logout } from './actions/User';
import { ErrorBoundary } from './components/ErrorBoundary';
import * as UsersActions from './actions/Users';
import './App.css';
// import CacheBuster from 'react-cache-buster';
// import {version} from '../package.json';

import Layout from './Layout';
import CountDownModal from './components/CountdownModal';
import moment from 'moment';
import { getTrunkGroupList } from './actions/Inteliquent';
import { getTdmRoutes } from './actions/tdm';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

import WebsiteNotificationBar from '../src/components/WebsiteNotificationBar';

library.add([
  faPaperclip,
  faUpload,
  faFile,
  faSignInAlt,
  faSignOutAlt,
  faAddressBook,
  faBuilding,
  faPowerOff,
  faMarker,
  faClock,
  faSignature,
  faCarBattery,
  faHashtag,
  faMicrochip,
  faDiceD20,
  faCalendarAlt,
  faMapMarkerAlt,
  faNetworkWired,
  faEthernet,
  faAddressCard,
  faEdit,
  faTrophy,
  faServer,
  faSimCard,
  faWindowClose,
  faKey,
  faAt,
  faChevronRight,
  faChevronLeft,
  faCaretLeft,
  faCaretRight,
  faPlus,
  faTimes,
  faSpinner,
  faCheck,
  faArrowsAlt,
  faSave,
  faCheckCircle,
  faFileDownload,
  faEye,
  faTrashAlt,
  faSort,
  faMinus,
  faCompressArrowsAlt,
  faPlug,
  faPlusCircle,
  faMapMarkedAlt,
  faListUl,
  faMinusCircle,
  faCaretUp,
  faCaretDown,
  faSortDown,
  faSortUp,
  faFileUpload,
  faFax,
  faUser,
  faGlobeAmericas,
  faLocationArrow,
  faUsers,
  faPhoneAlt,
  faLeaf,
  faTabletAlt,
  faBell,
  faWrench,
  faPhoneSquareAlt,
  faSmile,
  faFrown,
  faStar,
  faLock,
  faPhone,
  faQuestion,
  faDownload,
  faListAlt,
  faEye,
  faEyeSlash,
  faAngleDown,
  faWifi,
  faExclamationTriangle,
]);
require('dotenv').config();
const TIMEOUT_IN_MILI_SECONDS = 1000 * 60 * 30;
const TIMEOUT_IN_MINUTES = 30;
class App extends Component {
  constructor(props) {
    super(props);
    this.token = localStorage.getItem('jwtToken') || null;
    global.deleteMode = false;
    if (
      window.location.pathname.indexOf('/boxes/') !== -1 &&
      window.location.search.indexOf('&token=') !== -1
    ) {
      this.token = window.location.search.split('&token=').pop();
      localStorage.clear();
      localStorage.setItem('jwtToken', this.token);
    }
    if (!this.token || this.token === 'null' || this.token === 'undefined') {
      localStorage.removeItem('jwtToken');
      this.token = null;
    }
    props.getUserData(this.token);
    if (this.token) {
      props.getTrunkGroupList(this.token);
      props.getTdmRoutes(this.token);
    }
    this.idleTimer = null;
    this.state = {
      isModalOpen: false,
      currWidth: window.innerWidth,
      maintenanceText: '',
    };
    props.latestMaintenanceNote().then((result) => {
      if (result && result?.maintenanceAlert?.length > 0) {
        this.setState({
          maintenanceText: result?.maintenanceAlert[0]?.description,
        });
      }
    });
  }
  onIdle = () => {
    const { logout } = this.props;
    this.toggle();
    setTimeout(() => {
      logout(this.token);
      this.token = null;
    }, 1000);
    this.setState({
      timeoutDuration: null,
    });
    this.setBlurTimer();
  };

  toggle = () => {
    const { isModalOpen } = this.state;
    this.setState({ isModalOpen: !isModalOpen });
    this.setBlurTimer();
  };

  handleResize = () => this.setState({ currWidth: window.innerWidth });
  componentDidMount() {
    this.reAuthenticateUser();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('blur', this.setBlurTimer);
    window.addEventListener('focus', this.reAuthenticateUser);
    (async() => {
      const fp = await FingerprintJS.load();
      const {visitorId} = await fp.get();
      sessionStorage.setItem("userDeviceID", visitorId);
    })()
  }
  setBlurTimer = () => {
    localStorage.setItem('idle-timer', String(moment().toDate()));
  };
  reAuthenticateUser = () => {
    var previousTime = localStorage.getItem('idle-timer');
    var currentTime = moment();
    var duration = moment.duration(currentTime.diff(previousTime));
    var differenceInMinutes = duration.asMinutes();
    if (differenceInMinutes > TIMEOUT_IN_MINUTES + 1) {
      this.onIdle();
    }
  };

  componentWillUnmount() {
    this.setBlurTimer();
    window.removeEventListener('blur', this.setBlurTimer);
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('focus', this.reAuthenticateUser);
  }
  render() {
    const { isModalOpen, maintenanceText } = this.state;
    return (
      // <CacheBuster
      // currentVersion={version}
      // isEnabled={true}
      // isVerboseMode={true}
      // >
      <DndProvider
        backend={this.state.currWidth <= 1024 ? TouchBackend : HTML5Backend}
        options={{ enableMouseEvents: true }}
      >
        <div className="text-center">
          {!this.token && maintenanceText && (
            <WebsiteNotificationBar isOpen={true} >{maintenanceText}</WebsiteNotificationBar>
          )}
          <ErrorBoundary>
            {this.token && (
              <IdleTimer
                ref={ref => {
                  this.idleTimer = ref;
                }}
                element={document}
                onIdle={this.toggle}
                debounce={250}
                timeout={TIMEOUT_IN_MILI_SECONDS}
              />
            )}
            {this.token && (
              <CountDownModal toggle={this.toggle} isModalOpen={isModalOpen} onIdle={this.onIdle} />
            )}
            <ToastContainer autoClose={5000} position="top-left" />
            <Layout />
          </ErrorBoundary>
        </div>
      </DndProvider>
      // </CacheBuster>
    );
  }
}

const mapStateToProps = state => ({ store: state, user: state.AppState.user });
const mapDispatchToProps = dispatch => ({
  getUserData: token => dispatch(UserActions.getUserData(token)),
  getTrunkGroupList: token => dispatch(getTrunkGroupList(token)),
  getTdmRoutes: token => dispatch(getTdmRoutes(token)),
  getCompanies: (token, pagination, disablePaginate, onlyName) =>
    dispatch(
      CompanyActions.getCompanies(
        token,
        pagination,
        disablePaginate,
        undefined,
        undefined,
        onlyName,
      ),
    ),
  getBoxes: (token, companyId) => dispatch(BoxesActions.getEpikBoxesData(token, companyId)),
  getUsers: (token, pagination) => dispatch(UsersActions.getUsers(token, pagination)),
  logout: token => dispatch(logout(token)),
  latestMaintenanceNote: token => dispatch(BoxesActions.latestMaintenanceNote()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(App);
